import { useCallback, useRef } from 'react';

import {
    CHECK_ANIMATION_BUFFER_MS,
    CHECK_ANIMATION_DURATION_MS,
} from '@perpay-web/fintech/constants/animation';
import { useFireworks } from '@perpay-web/fintech/hooks/useFireworks';
import { useMountAndUnmount } from '@perpay-web/hooks/useMountAndUnmount';

const useLoaderStepTimeout = (loaderStep, setNextStep) => {
    const { startFireworks } = useFireworks();
    const navigateTimerIdRef = useRef(null);

    const triggerTimeout = useCallback(() => {
        const timeoutMs =
            loaderStep === 0
                ? CHECK_ANIMATION_DURATION_MS + CHECK_ANIMATION_BUFFER_MS
                : 0;

        navigateTimerIdRef.current = window.setTimeout(() => {
            setNextStep();
            startFireworks();
        }, timeoutMs);
    }, [loaderStep, setNextStep, startFireworks]);

    useMountAndUnmount(() => {
        triggerTimeout();

        return () => {
            if (navigateTimerIdRef.current) {
                window.clearTimeout(navigateTimerIdRef.current);
            }
        };
    });
};

export default useLoaderStepTimeout;
